/**
 * The custom error to be thrown when execution exceeds it's limit.
 */
export class ExecutionLimitError extends Error {
    constructor(maxExecutionTime: number) {
        super();
        this.message = `Execution max limit ${maxExecutionTime}ms reached`;
    }
}

/**
 * Rejects a promise after a given time
 *
 * @param time - The time in ms to reject after.
 */
const rejectAfter = <T>(time: number): Promise<T> =>
    new Promise((_resolve, reject) => setTimeout(() => reject(new ExecutionLimitError(time)), time));

/**
 * Limits a given promise execution under a given time.
 *
 * @param promise - The promise to limit it's execution.
 * @param [time] - The time to limit promise execution.
 */
export const limitExecution = <T>(promise: Promise<T>, time?: number): Promise<T> =>
    time ? Promise.race([promise, rejectAfter<T>(time)]) : promise;

export const baseUrl = ({ serviceUrl }: { serviceUrl: string }): string => `http://${serviceUrl}/api/v2`;
